import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles'
import LoginIcon from '@mui/icons-material/Login';
import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
import LogoutIcon from '@mui/icons-material/Logout';
import { AppBar, Toolbar, CssBaseline, Typography } from "@mui/material";
import styles from './cabecalho.module.css';
import Toast from '../../components/Toast/Toast';
import loginService from '../../paginas/login/service/login.service';
import { UserContext } from '../../contexts/UserContext';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import NavItem from '../../components/NavItem/NavItem';


const useStyles = makeStyles((theme: any) => ({
    header: {
        background: '#053616',
        height: '10vh',
    },
    navlinks: {
        display: "flex",
        textDecoration: "none",
        marginRight: 5,
    },
    logo: {
        flexGrow: "2",
        cursor: "pointer",
    },
}));


export default function Cabecalho() {
    const classes = useStyles();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isToast, setIsToast] = useState(false);
    const [user, setUser] = useState('');
    const [isMenuOpen, setOpenMenu] = useState(false);
    const { user_role } = useContext(UserContext);
    const [inicio, setInicio] = useState('');
    const { t } = useTranslation();

    const handleIdioma = (novoIdioma: string) => {
        i18n.changeLanguage(novoIdioma);
    };

    const sair = () => {
        setIsToast(true);
        setUser('');
        setOpenMenu(!isMenuOpen);

        setTimeout(() => {
            const resp = loginService.logout()
            setIsToast(false);

        }, 100)
    }

    const [isToken, setIsToken] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        loginService.observable.onToken().subscribe((token: any) => {
            if (token) {
                setIsToken(true);
                setInicio('/pagina-inicial')
            }
            if (token === null) {
                setIsToken(false);
                setInicio('/')
            }
        });
        loginService.observable.setToken(loginService.getToken())

    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    function toggleNavMenu() {
        setOpenMenu(!isMenuOpen);
    }


    return (
        <>
            <Toast open={isToast} mensagem={'Ate logo!'} timer={3000} />
            {
                windowWidth > 800
                    ?
                    <AppBar position="static">
                        <CssBaseline />
                        <Toolbar className={styles.header}>
                            <div className={styles.peticoesOptions}>
                                <Link to={inicio} className={styles.logo}>
                                    <img src={`${process.env.PUBLIC_URL}/assets/imagens/dpu-logo-degrade.png`} alt="DPU" style={{ height: '70px' }} />
                                </Link>
                                <Link to="/">
                                    {t('menuCadastrarDenuncia')}
                                </Link>
                                <Link to="acompanhar-peticao">
                                    {t('menuAcompanharDenuncia')}
                                </Link>
                            </div>
                            <div className={classes.navlinks}>
                                {isToken ?
                                    <>
                                        <div className={styles.menuContainer}>
                                            <div className={styles.menuGrid}>
                                                <div className={styles.itemsGrid}>
                                                    <div className={styles.menuItem}>
                                                        <div className={styles.dropdown}>
                                                            <button className={styles.dropdownBtn}>
                                                                Petições
                                                                <ArrowDown />
                                                            </button>
                                                            <div className={styles.dropdownContent}>
                                                                <Link to="list-formulario-peticao">
                                                                    <span>Listar formulários</span>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {(user_role == 1 || user_role == 2) &&

                                                        <div className={styles.menuItem}>
                                                            <div className={styles.dropdown}>
                                                                <button className={styles.dropdownBtn}>
                                                                    Usuários
                                                                    <ArrowDown />
                                                                </button>
                                                                <div className={styles.dropdownContent}>
                                                                    <Link to="list-usuario">
                                                                        <span>Listar usuários</span>
                                                                    </Link>
                                                                    <Link to="create-usuario">
                                                                        <span>Criar usuário</span>
                                                                    </Link>
                                                                    {(user_role == 1) &&
                                                                        <Link to="gerenciamento-aplicacao">
                                                                            <span>Gerenciamento</span>
                                                                        </Link>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                <Link to="/" className={styles.link} onClick={sair} title='Sair'>
                                                    <LogoutIcon sx={{ fontSize: 35 }} />
                                                </Link>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    
                                    /*
                                    <Link to="login" className={styles.link} title='Entrar'>
                                        <AccountCircle sx={{ fontSize: 35 }} />
                                    </Link>
                                    */

                                    /*
                                    <div className={styles.languagesOptions}>
                                        <Link to="#" onClick={() => handleIdioma('pt')}>
                                            Português
                                        </Link>
                                        {' | '}
                                        <Link to="#" onClick={() => handleIdioma('en')}>
                                            Inglês
                                        </Link>
                                        {' | '}
                                        <Link to="#" onClick={() => handleIdioma('es')}>
                                            Espanhol
                                        </Link>
                                        {' | '}
                                        <Link to="#" onClick={() => handleIdioma('fr')}>
                                            Francês
                                        </Link>
                                    </div>
                                    */
                                   ''
                                }
                            </div>
                        </Toolbar>
                    </AppBar>
                    :
                    <section className={styles.hamburgerMenu}>
                        <div className={styles.menuOptions}>
                            <div className={styles.peticoesOptions}>
                                <Link to="/">
                                    Cadastrar petição
                                </Link>
                                <Link to="acompanhar-peticao">
                                    Acompanhar petição
                                </Link>
                            </div>
                            <button onClick={toggleNavMenu}>
                                <MenuIcon style={{ color: 'white', fontSize: 40 }} />
                            </button>
                        </div>

                        {isMenuOpen &&
                            <>
                                <div className={styles.menuOverlay}></div>
                                <div className={styles.menuOpened}>
                                    <div>
                                        <button className={styles.closeNavMenu} onClick={toggleNavMenu}>
                                            <CloseIcon style={{ color: 'white', fontSize: 40 }} />
                                        </button>
                                    </div>
                                    <div>
                                        {
                                            isToken &&
                                            <div className={styles.menuNavOptions}>
                                                <NavItem title="Petições">
                                                    <button onClick={event => window.location.href = '/list-formulario-peticao'}>
                                                        <span>Listar formulários</span>
                                                    </button>
                                                </NavItem>
                                                <NavItem title="Usuários">
                                                    <button onClick={event => window.location.href = '/list-usuario'}>
                                                        <span>Listar usuários</span>
                                                    </button>
                                                    <button onClick={event => window.location.href = '/create-usuario'}>
                                                        <span>Criar usuário</span>
                                                    </button>
                                                    {(user_role == 1) &&
                                                        <button onClick={event => window.location.href = '/gerenciamento-aplicacao'}>
                                                            <span>Gerenciamento</span>
                                                        </button>
                                                    }
                                                </NavItem>
                                            </div>
                                        }
                                    </div>
                                    <div className={styles.footerLink}>
                                        {
                                            isToken
                                                ?
                                                <Link to="/" onClick={sair} title='Sair'>
                                                    <LogoutIcon style={{ color: 'white', fontSize: 40 }} />
                                                </Link>
                                                :
                                                <a href="login" title='Entrar'>
                                                    <AccountCircle style={{ color: 'white', fontSize: 40 }} />
                                                </a>
                                        }
                                        <p className={styles.copyright}>DPU &copy;</p>
                                    </div>
                                </div>
                            </>
                        }
                    </section>
            }
        </>

    )
}